module.exports = __webpack_public_path__ + "media/images/logo-ae27bdd38f42dd61f42ba65d1aed3dee.png";